import { CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Avatar, FloatButton } from "antd";
import { List, Toast } from "antd-mobile";
import axios from "axios";
import $ from "jquery";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactFileReader from "react-file-reader";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { getFileLiveUrl, jsonToQuery, momentDate } from "../../utils";
import { SELECT_USER_PHOTO } from "../../utils/data";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

const Award = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showAdd1, setShowAdd1] = useState(false);
  const [showView, setShowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [totalBalance, setTotalBalance] = useState(0);
  const [showFeeModal, setShowFeeModal] = useState(false);
  const [viewData, setViewData] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [oldFile, setOldFile] = useState("");
  const [showList, setShowList] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showListView, setShowListView] = useState(false);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });

  useEffect(() => {
    if (!loader) getReport();
  }, [JSON.stringify(tableParams.pagination)]);

  const getRandomuserParams = (params) => ({
    limit: params.pagination?.pageSize,
    page: params.pagination?.current,
    name: params.pagination?.name,
    from_date: params.pagination?.from_date,
    to_date: params.pagination?.to_date,
    // academic_department: params.pagination?.academic_department,
    //...params,
  });

  const fileReaderChange = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      alert("Please select an Image with file extension .jpg or .png", "error");
      return;
    }

    if (file.fileList[0].size < 10000) {
      alert("File size must greater than 10 kb", "error");
      return;
    }

    if (file.fileList[0].size > 300000) {
      alert("File size must less than 300 kb", "error");
      return;
    }

    setSelectedFile(file.base64);
  };

  const clearFile = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFile("");
  };

  const getImage = () => {
    if (selectedFile && selectedFile.length > 0) return selectedFile;
    else if (oldFile && oldFile.length > 0) return getFileLiveUrl(oldFile);
    return SELECT_USER_PHOTO;
  };

  useEffect(() => {
    if (props.profilePhoto) setOldFile(props.profilePhoto);
  }, [props.profilePhoto]);

  const getReport = () => {
    setLoader(true);
    setDataList([]);
    setDataView([]);
    const form = new FormData();

    axios
      .post(
        ServiceUrl.STUDENTS.LIST_STUDENT_AWARD +
          "?" +
          jsonToQuery(getRandomuserParams(tableParams)) +
          "&student_uuid=" +
          context.user.uuid
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setDataView(res["data"].data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res["data"].count,
              // 200 is mock data, you should read it from server
              // total: data.totalCount,
            },
          });
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };
  // console.log(showView.name);
  const handleView = (item) => {
    setShowView(item);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);
    axios
      .post(ServiceUrl.STUDENTS.SAVE_STUDENT_AWARD, $("#frm_add").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Saved" });
          setLoader(false);
          document.getElementById("frm_add").reset();
        } else {
          Toast.show({ content: res["data"].message || "Error" });
          setLoader(false);
        }
      });
  };

  return (
    <>
      <Header title="Award" backAction={true} rightActions={[]} />
      {showList && (
        <div className="page-content-wrapper">
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                AWARD{" "}
                <FloatButton
                  icon={<PlusCircleOutlined style={{ verticalAlign: "3px" }} />}
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowList(false);

                    setShowForm(true);
                  }}
                />
              </Card.Header>
              <Card.Body className="fs-6">
                <br />
                <List>
                  {dataView.map((item) => (
                    <List.Item
                      key={item.company_name}
                      prefix={
                        <Avatar
                          style={{
                            backgroundColor: "#f56a00",
                            verticalAlign: "middle",
                            textTransform: "uppercase",
                          }}
                          size="large"
                        >
                          {item.name.charAt(0)}
                        </Avatar>
                      }
                      onClick={(e) => {
                        // handleView(item);
                        // setShowList(false);
                        // setShowForm(false);
                      }}
                    >
                      {item.name} <br />
                      {item.event_name}
                      <br />
                      {momentDate(item.from_date, "DD-MM-YYYY")} -
                      {momentDate(item.to_date, "DD-MM-YYYY")}
                    </List.Item>
                  ))}
                </List>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
      {showForm && (
        <div className="page-content-wrapper">
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                ADD AWARD{" "}
                <FloatButton
                  icon={
                    <CloseCircleOutlined style={{ verticalAlign: "3px" }} />
                  }
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowForm(false);
                    setShowList(true);
                  }}
                />
              </Card.Header>
              <Card.Body>
                <Form noValidate id="frm_add" onSubmit={handleSubmit}>
                  <input
                    type="hidden"
                    name="student_uuid"
                    value={context.user.uuid}
                  />

                  <input
                    type="hidden"
                    name="certificate"
                    value={selectedFile}
                  />
                  <Row>
                    <Col md={4}>
                      <Form.Label className="fs-sm">
                        Activity Type <span className="text-danger">*</span>
                      </Form.Label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="select"
                        className="fw-bold form-select form-select-md"
                        name="activity_type"
                        required
                      >
                        <option value="">--Select--</option>
                        <option value="culturals">Culturals</option>
                        <option value="games">Games</option>
                        <option value="symposism">Symposism</option>
                        <option value="sports">Sports</option>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <Form.Label className="fs-sm">
                        Venue<span className="text-danger">*</span>
                      </Form.Label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        className="fw-bold text-uppercase mt-2"
                        size="sm"
                        name="venue"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <Form.Label className="fs-sm">
                        From date <span className="text-danger">*</span>
                      </Form.Label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="date"
                        className="fw-bold text-uppercase mt-2"
                        size="sm"
                        name="from_date"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        To date <span className="text-danger">*</span>
                      </label>
                    </Col>

                    <Col md={4}>
                      <Form.Control
                        type="date"
                        className="fw-bold text-uppercase mt-2"
                        size="sm"
                        name="to_date"
                        required
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Name of the Event<span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="event_name"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Description<span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="description"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">Certificate/Shield</label>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="certificate"
                          value={selectedFile}
                        />
                        {selectedFile && selectedFile.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFile()}
                          >
                            x
                          </a>
                        )}
                        {selectedFile && selectedFile.length > 0 && (
                          <img
                            src={getImage()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChange}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFile && selectedFile.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <Row>
                    <Col md={4}></Col>
                    <Col md={4} className="text-end">
                      <Button
                        type="submit"
                        variant="success"
                        className="btn btn-block "
                      >
                        save
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};
export default Award;
